/**
 * Shared action utilities for cantera stats module.
 * Used by EstadisticasNew, GameCenterVideo, GameCenterEstadisticas, CanteraStatsTab.
 */

export const ACTION_CODES = {
  // Tirs
  TWO_PTS_MADE: '2PTS_MADE',
  TWO_PTS_MISSED: '2PTS_MISSED',
  THREE_PTS_MADE: '3PTS_MADE',
  THREE_PTS_MISSED: '3PTS_MISSED',
  FREE_THROW_MADE: 'FT_MADE',
  FREE_THROW_MISSED: 'FT_MISSED',
  // Rebonds
  OFFENSIVE_REBOUND: 'REB_OFF',
  DEFENSIVE_REBOUND: 'REB_DEF',
  // Autres actions
  ASSIST: 'AST',
  STEAL: 'STL',
  TURNOVER: 'TO',
  BLOCK: 'BLK',
  FOUL: 'FOUL',
  FOUL_RECEIVED: 'FOUL_RCV',
  SCREEN: 'SCREEN',
  TIMEOUT: 'TIMEOUT',
  TECHNICAL: 'TECH',
  // Phase 3
  CHARGE_TAKEN: 'CHARGE_TAKEN',
  CHARGE_DRAWN: 'CHARGE_DRAWN',
  DEFLECTION: 'DEFLECTION',
  OPP_SCORE_2: 'OPP_2PTS',
  OPP_SCORE_3: 'OPP_3PTS',
  OPP_SCORE_FT: 'OPP_FT',
};

export const getActionLabel = (actionCode, t) => {
  if (actionCode && actionCode.startsWith && actionCode.startsWith('Tag:')) {
    return actionCode;
  }
  return t(`estadisticasNew.actionCodes.${actionCode}`, { defaultValue: actionCode });
};

export const getActionColor = (actionCode) => {
  switch (actionCode) {
    case ACTION_CODES.THREE_PTS_MADE:
      return '#4caf50';
    case ACTION_CODES.TWO_PTS_MADE:
      return '#8bc34a';
    case ACTION_CODES.FREE_THROW_MADE:
      return '#cddc39';
    case ACTION_CODES.TWO_PTS_MISSED:
    case ACTION_CODES.THREE_PTS_MISSED:
    case ACTION_CODES.FREE_THROW_MISSED:
      return '#f44336';
    case ACTION_CODES.ASSIST:
      return '#ff9800';
    case ACTION_CODES.OFFENSIVE_REBOUND:
      return '#03a9f4';
    case ACTION_CODES.DEFENSIVE_REBOUND:
      return '#00bcd4';
    case ACTION_CODES.STEAL:
      return '#9c27b0';
    case ACTION_CODES.TURNOVER:
      return '#e91e63';
    case ACTION_CODES.BLOCK:
      return '#009688';
    case ACTION_CODES.FOUL:
    case ACTION_CODES.FOUL_RECEIVED:
      return '#ff6f00';
    case ACTION_CODES.TECHNICAL:
      return '#d32f2f';
    case ACTION_CODES.CHARGE_TAKEN:
      return '#7b1fa2';
    case ACTION_CODES.CHARGE_DRAWN:
      return '#4a148c';
    case ACTION_CODES.DEFLECTION:
      return '#00695c';
    case ACTION_CODES.OPP_SCORE_2:
    case ACTION_CODES.OPP_SCORE_3:
    case ACTION_CODES.OPP_SCORE_FT:
      return '#b71c1c';
    default:
      if (actionCode && actionCode.startsWith && actionCode.startsWith('Tag:')) return '#1976d2';
      return '#607d8b';
  }
};
